import React, { useState } from 'react';
import defaultAvatar from '../../assets/default-avatar.png';

const ProfileHeader = ({ user }) => {
  const [avatar, setAvatar] = useState(defaultAvatar);
  
  const handleAvatarChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setAvatar(reader.result);
        // Here you would typically upload the image to your backend/storage
      };
      reader.readAsDataURL(file);
    }
  };

  return (
    <div className="profile-header">
      <div className="avatar-container">
        <img src={avatar} alt="Profile" className="profile-avatar" />
        <div className="avatar-overlay">
          <label htmlFor="avatar-upload" className="avatar-upload-label">
            <span className="material-icons">photo_camera</span>
          </label>
          <input 
            type="file" 
            id="avatar-upload" 
            accept="image/*" 
            onChange={handleAvatarChange} 
            className="avatar-upload-input" 
          />
        </div>
      </div>
      
      <div className="profile-info">
        <h1>{user?.username || 'Golfer'}</h1>
        <p className="profile-email">{user?.attributes?.email || 'No email provided'}</p>
        <p className="profile-member-since">Member since: {new Date().toLocaleDateString()}</p>
      </div>
    </div>
  );
};

export default ProfileHeader;
